import { featureflagApi } from "../api/featureflag.api";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { FeatureFlag } from "../types/featureflag.typer";

type FeatureFlagsReturn = Partial<FeatureFlag> & {
  invalidateFeatureFlagsQuery: () => Promise<void>;
  isLoading: boolean;
};

export const useFeatureFlags = (): FeatureFlagsReturn => {
  const { data, isLoading } = useQuery({
    queryKey: ["featureFlags"],
    queryFn: () => featureflagApi.hentFeatureFlags(),
    throwOnError: true,
  });
  const queryClient = useQueryClient();

  return {
    environment: data?.environment,
    fornaermetTyper: data?.fornaermetTyper,
    aktiverTilgangsstyring: data?.aktiverTilgangsstyring,
    vedleggConstants: data?.vedleggConstants,
    anmeldelseTyper: data?.anmeldelseTyper,
    aktiverVirksomhetensReferanse: data?.aktiverVirksomhetensReferanse,
    aktiverGjerningsaktorer: data?.aktiverGjerningsaktorer,
    invalidateFeatureFlagsQuery: () =>
      queryClient.invalidateQueries({
        queryKey: ["featureFlags"],
      }),
    isLoading: isLoading,
  };
};
